import { getYouTubeVideoIdFromUrl, isYoutubeUrl } from "@modules/ui/components/richText/richTextUtils"
import { useWindowSize } from "@modules/utils/hooks/useWindowsSize"
import Link from "@tiptap/extension-link"
import Underline from "@tiptap/extension-underline"
import { EditorContent, useEditor } from "@tiptap/react"
import StarterKit from "@tiptap/starter-kit"
import { Dialog } from "primereact/dialog"
import { useState } from "react"
import styled, { css } from "styled-components"

type HURichTextViewProps = {
  value: string
  paragrapheFontStyle: "BL" | "BM" | "BS" | "BXS" | "TL"
  numberOfLine?: number
} & React.ComponentProps<"label">

export const HURichTextView: React.FC<HURichTextViewProps> = ({
  value = "",
  paragrapheFontStyle,
  numberOfLine,
  className = "",
  ...props
}) => {
  const [shownVideoUrl, setShownVideoUrl] = useState<string>()
  const { width } = useWindowSize()
  const editor = useEditor({
    extensions: [StarterKit, Underline, Link],
    content: value,
    editable: false,
  })

  const videoWidth = width * 0.8
  const videoHeight = (videoWidth * 9) / 16

  return (
    <Component $numberOfLine={numberOfLine} {...props}>
      <EditorContent
        editor={editor}
        className={"hu-richtext-view " + paragrapheFontStyle + " " + className}
        readOnly={true}
        onClick={(e) => {
          const link = (e.target as HTMLElement).closest("a")
          if (link && isYoutubeUrl(link.href)) {
            e.preventDefault()
            const videoId = getYouTubeVideoIdFromUrl(link.href)
            if (videoId) {
              const embedUrl = `https://www.youtube.com/embed/${videoId}?rel=0?version=3&autoplay=1&autopause=0&muted=1&controls=1`

              setShownVideoUrl(embedUrl)
            }
          }
        }}
      />

      {!!shownVideoUrl && (
        <Dialog
          className="min-w-0"
          modal
          blockScroll
          onShow={() => {
            document.body.classList.add("p-overflow-hidden")
          }}
          onHide={() => {
            document.body.classList.remove("p-overflow-hidden")
            setShownVideoUrl(undefined)
          }}
          style={{ width: videoWidth, height: videoHeight, padding: 0 }}
          contentStyle={{ minWidth: videoWidth, height: videoHeight, padding: 0, overflow: "hidden", borderRadius: 5 }}
          visible={true}
          showHeader={false}
          dismissableMask={true}
        >
          <iframe
            src={shownVideoUrl}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded youtube"
            width="100%"
            height="100%"
            style={{ border: 0 }}
          />
        </Dialog>
      )}
    </Component>
  )
}

const Component = styled.label<{
  $numberOfLine?: number
}>`
  ${({ $numberOfLine }) =>
    $numberOfLine &&
    css`
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${$numberOfLine};
      overflow: hidden;
    `}
`
